  import './polyfills';
  import ReactDOM from 'react-dom/client';
  import './index.css';
  import App from './App';
  import reportWebVitals from './reportWebVitals';
  import { store } from './contexts/store';
  import { Provider } from 'react-redux';
  import config from 'devextreme/core/config';
  import { AppErrorBoundary } from './AppErrorBoundary';

  config({
    editorStylingMode: 'outlined',
    defaultCurrency: 'COP',
    decimalSeparator: ',',
    thousandsSeparator: '.',
  });

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <Provider store={store}>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </Provider>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
